import React from 'react'
import { Button, Form, FormGroup, Input, Label, Row, Col, ModalBody, ModalFooter, ModalHeader } from 'reactstrap'
import axios from '../utils/posAxios'
import { MdDone, MdClear } from 'react-icons/md'
import StorageService from '../services/StorageService'

class PosScheduleForm extends React.Component {
  _isMounted = true
  constructor(props) {
    super(props)
    this.state = {
      isEdit: false,
      isGlobal: '',
      store_id: '',
      scheduleList: [],
      schedule_id: '',
      name: '',
      advance_days: '',
      service_type: '',
      advance_min: '',
      location: '',
      allow_onlymod: '',
      pickup: false,
    }
  }

  componentDidMount() {
    if (this.props.data.isEdit) {
      let data = this.props.data
      this.setState({
        isGlobal: data.isGlboal,
        isEdit: data.isEdit,
        schedule_id: data.schedule_id,
        advance_days: data.advance_days,
        advance_min: data.advance_min,
        location: data.location,
        allow_onlymod: data.allow_onlymod,
        pickup: data.pickup,
        name: data.name,
      })
    } else {
      this.getScheduleList()
    }

    this.setState({
      isGlobal: this.props.data.isGlobal,
      store_id: this.props.data.store_id,
    })
  }

  componentWillUnmount() {
    this._isMounted = false
  }

  changeHandler = event => {
    this.setState({
      [event.target.name]: event.target.value,
    })
  }

  checkHandler = event => {
    let { name } = event.target
    this.setState({
      [name]: !this.state[name],
    })
  }

  handleSubmit = event => {
    event.preventDefault()
    const user = StorageService.getSession('user_info')
    const comp = StorageService.getSession('selected_org')
    const url = process.env.REACT_APP_UNITY_API2_URL

    if (this.state.isGlobal) {
      if (!this.state.isEdit) {
        this.createSchedule(user, comp, url)
      } else {
        this.editSchedule(user, comp, url)
      }
    } else {
      this.addSchedule(user, comp, url)
    }
  }

  getScheduleList = () => {
    const user = StorageService.getSession('user_info')
    const comp = StorageService.getSession('selected_org')
    const url = process.env.REACT_APP_UNITY_API2_URL

    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      company_id: comp.CompanyID,
    }

    axios
      .post(url + ':3001/v1/schedule', data)
      .then(response => {
        const result = response.data
        const storeSchedule = this.props.data.scheduleList

        let ScheduleOp = result.data.filter(x => !storeSchedule.some(y => y.schedule_id === x.schedule_id))
        if (result.error == true && result.message != 'Success') {
          alert(result.message)
          return
        }
        if (this._isMounted) {
          this.setState({ scheduleList: ScheduleOp })
        }
      })
      .catch(error => {
        alert(error)
      })
  }

  addSchedule(user, comp, url) {
    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      schedule_id: this.state.schedule_id,
      store_id: this.state.store_id,
      type: this.state.schedule_type,
      added_by: user.email,
    }
    axios
      .post(url + ':3001/v1/store/schedule/add', data)
      .then(response => {
        const result = response.data
        if (result.error == true) {
          this.props.closeModal(<MdClear />, result.message, 'error', false)
          return
        }

        this.props.closeModal(<MdDone />, 'New schedule added successfully.', 'success', false)
      })
      .catch(error => {
        alert(error)
      })
  }

  createSchedule(user, comp, url) {
    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      company_id: comp.CompanyID,
      name: this.state.name,
      advance_days: this.state.advance_days,
      advance_min: this.state.advance_min,
      allow_onlymod: this.state.allow_onlymod ? '1' : '0',
      location: this.state.location,
      pickup: this.state.pickup ? '1' : '0',
      created_by: user.email,
    }

    axios
      .post(url + ':3001/v3/schedule/create', data)
      .then(response => {
        const result = response.data
        if (result.error == true) {
          this.props.closeModal(<MdClear />, result.message, 'error', false)
          return
        }

        this.props.closeModal(<MdDone />, 'New schedule added successfully.', 'success', false)
      })
      .catch(error => {
        alert(error)
      })
  }

  editSchedule(user, comp, url) {
    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      schedule_id: this.state.schedule_id,
      name: this.state.name,
      advance_days: this.state.advance_days,
      advance_min: this.state.advance_min,
      allow_onlymod: this.state.allow_onlymod ? '1' : '0',
      location: this.state.location,
      pickup: this.state.pickup ? '1' : '0',
      update_by: user.email,
    }

    axios
      .post(url + ':3001/v3/schedule/update', data)
      .then(response => {
        const result = response.data
        if (result.error == true) {
          this.props.closeModal(<MdClear />, result.message, 'error', false)
          return
        }

        this.props.closeModal(
          <MdDone />,
          'Schedule updated successfully.',
          'success', //'error' post when return error
          false,
        )
      })
      .catch(error => {
        alert(error)
      })
  }

  render() {
    return (
      <Form className="AuthForm" onSubmit={this.handleSubmit}>
        <ModalHeader toggle={this.props.onToggleModal()}>Schedule</ModalHeader>
        <ModalBody>
          <Row>
            <Col md={12}>
              {this.state.isGlobal ? (
                <>
                  <FormGroup>
                    <Label>Schedule Name</Label>
                    <Input type="text" name="name" value={this.state.name} onChange={this.changeHandler} required />
                  </FormGroup>
                  <FormGroup>
                    <Label>Advance Days</Label>
                    <Input type="number" name="advance_days" value={this.state.advance_days} onChange={this.changeHandler} required />
                  </FormGroup>
                  <FormGroup>
                    <Label>Minimum Day</Label>
                    <Input type="number" name="advance_min" value={this.state.advance_min} onChange={this.changeHandler} />
                  </FormGroup>
                  <FormGroup check>
                    <Label check>
                      <Input type="checkbox" name="allow_onlymod" checked={this.state.allow_onlymod} onChange={this.checkHandler} />
                      Allow Only Date
                    </Label>
                  </FormGroup>
                  <FormGroup>
                    <Label>Location</Label>
                    <Input type="text" name="location" value={this.state.location} onChange={this.changeHandler} maxLength={255} />
                  </FormGroup>
                  <FormGroup check>
                    <Label check>
                      <Input type="checkbox" name="pickup" onChange={this.checkHandler} checked={this.state.pickup} />
                      Delivery Pickup (System will select the earliest available date. User date selection will be disabled)
                    </Label>
                  </FormGroup>
                </>
              ) : (
                <>
                  <FormGroup>
                    <Label></Label>
                    <Input type="select" name="schedule_id" value={this.state.schedule_id} onChange={this.changeHandler} required>
                      <option></option>
                      {this.state.scheduleList.length > 0 &&
                        this.state.scheduleList.map(item => {
                          return (
                            <option key={item.schedule_id} value={item.schedule_id}>
                              {item.name}
                            </option>
                          )
                        })}
                    </Input>
                  </FormGroup>
                  <FormGroup>
                    <Label>Type</Label>
                    <Input type="select" name="schedule_type" value={this.state.schedule_type} onChange={this.changeHandler} required>
                      <option></option>
                      <option value="Delivery">Delivery</option>
                      <option value="Service Order">Service Order</option>
                      <option value="Self Collection">Self Collection</option>
                      <option value="Direct Order">Direct Order</option>
                      <option value="Table Service">Table Service</option>
                      {/* <option value="Dine In">Dine In</option> */}
                    </Input>
                  </FormGroup>
                </>
              )}
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button className="theme-button theme-button-secondary" onClick={this.props.onToggleModal()}>
            Close
          </Button>
          <Button className="theme-button theme-button-primary" type="submit">
            Save
          </Button>
        </ModalFooter>
      </Form>
    )
  }
}

export const STATE_ADD = 'ADD'
export const STATE_EDIT = 'EDIT'
export default PosScheduleForm
